export default __webpack_public_path__ + "static/media/gameinformations.8c098759.png";